// 細分化画像の推論処理を行う。画像をアップロード、AI推論リクエスト、返却された推論結果を描写
// base lib
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import { v4 as uuidv4 } from 'uuid';
import  * as moment from 'moment';
// 画像切り取りライブラリ
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
// material-ui
import { Typography, Paper, Button, Grid } from '@material-ui/core';
import CloudUpload from '@material-ui/icons/CloudUpload';
import RotateRight from '@material-ui/icons/RotateRight';
import RotateLeft from '@material-ui/icons/RotateLeft';
import Rotate90 from '@material-ui/icons/Rotate90DegreesCcw';
// redux
import { IAppState, kansatsuKirokuSubdivOperations } from '../../redux/modules';
import { inferenceResultSubdivOperations } from '../../redux/modules';
import { SiteInfoListSubdivState } from '../../redux/modules/siteInfoListSubdiv';
import { InferenceResultSubdivState } from '../../redux/modules/inferenceSubdiv';
import { KansatsuKirokuSubdivState } from '../../redux/modules/kansatsuKirokuSubdiv';
// model
import { SiteInfo } from '../../models/SiteInfo';
import { CloseBackButton } from '../parts/CloseBackButton';
import { KansatsuKirokuSubdiv } from '../../models/KansatsuKirokuSubdiv';
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';
// other components
import SelectPicture from '../SelectPicture';
// import { InferenceResultSubdivView } from '../parts/InferenceResultSubdivView';
import KansatsuKirokuEdit from '../parts/KansatsuKirokuEdit'; // 観察記録のテキスト入力エリア
import KansatsuKirokuScoreEditForSubdiv, { DEFAULT_ROCK_MASS_GROUP_ID } from '../parts/KansatsuKirokuScoreEditForSubdiv'; // 総合評価表の表示 観察記録のスコア入力エリア


// @ts-ignore
const createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  // ページ情報
  match: any; // withRouterにより設定される
  history: H.History; // ページ履歴情報
  sites: SiteInfoListSubdivState; // 該当工事の 工事名、工事番号、画像切り出しサイズ情報
  // 関数
  clear: () => void; // このページでは利用しない
  execute: ({ koujiBangou, inferenceId, imageStr, contentType }
      :{ koujiBangou: string, inferenceId: string, imageStr:string, contentType:string, completeHandler: () => any }) => any; // 推論実行
  reset: () => any; // InferenceResultSubdivStateを初期値に戻す
  getRecord: ({ koujiBangou, key, completeHandler }
      :{ koujiBangou: string, key: string, completeHandler: () => any }) => any; // このページでは利用しない
  postRecord: (record: KansatsuKirokuSubdiv, originalImageStr: string, originalImageContentType: string, completeHandler: () => any) => any // 推論結果を保存する
  // ↓ 追加: 最新の岩石グループを取得する関数
  getLatestRockMassGroup: (params: { koujiBangou: string }) => Promise<{ rockMassGroup: string | undefined } | void>;
  // 変数
  inferenceResult: InferenceResultSubdivState; // 推論結果情報
  kansatsuKirokuSubdiv: KansatsuKirokuSubdivState; // 該当工事番号のレコード一覧と選択されているレコードの情報
}

interface OwnState {
  sourceImage: string; // 選択したファイルの内容
  isSetPreview: boolean; // プレビューが設定されているか
  site: SiteInfo; // 工事現場の情報
  inferenceId: string; // 推論ID

  lineNum: number;                   // 細分化 行サイズ
  columnNum: number;                 // 細分化 列サイズ
  observationNames: string[];        // 観察項目名
  observationDescriptions: string[]; // 観察項目_説明

  coordinatesResultsOrg: KansatsuKirokuObsrec['observationsScores'];
  selectedRockMassGroup: string; // 選択された岩石グループID
}

class InferenceSubdivPage extends React.Component<OwnProps, OwnState>{
  private cropperElement;
  private previewCanvasElement;
  private kansatsuKirokuSubdivEditElement;
  private kansatsuKirokuObsrecScoreEditElement: KansatsuKirokuScoreEditForSubdiv;
  // private croppedImgElement: HTMLImageElement | null;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      sourceImage: '',
      isSetPreview: false,
      site: new SiteInfo(),
      inferenceId: '',
      lineNum: 0,
      columnNum: 0,
      observationNames: [],
      observationDescriptions: [],
      coordinatesResultsOrg:[],
      selectedRockMassGroup: DEFAULT_ROCK_MASS_GROUP_ID, // デフォルト値を設定
    };
    this.handleRockMassGroupChange = this.handleRockMassGroupChange.bind(this); // bind を追加
  }

  /**
   * 以下のルールで推論IDを生成する
   * 工事番号-YYYYMMDDHHmmss-UUIDv4
   */
  generateInferenceId():string {
    return `${
      this.props.match.params.koujibangou
    }-${
      moment().format('YYYYMMDDHHmmss')
    }-${
      uuidv4()
    }`;
  }

  /**
   * 画像ファイルが選択されたらStateを更新する。
   * stateがCropperのsrcに設定されているのでCropperに画像が表示される
   */
  pictureFileSelected(src: string) {
    // ファイルが選択されたときだけ画像を設定する.
    if (src) {
      this.setState({ sourceImage: src });
    }
  }
  async componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/subdiv/sitelist');
      return ;
    }
    // siteInfo の設定は先に行う
    this.setState({
      site: siteInfo,
      lineNum: siteInfo.lineNum,
      columnNum: siteInfo.columnNum,
      observationNames: siteInfo.observationNames,
      observationDescriptions: siteInfo.observationDescriptions
    });

    // --- ↓ 最新の岩石グループを取得して state を更新 ---
    try {
      const result = await this.props.getLatestRockMassGroup({ koujiBangou });
      if (result && result.rockMassGroup) {
        this.setState({ selectedRockMassGroup: result.rockMassGroup });
      } else {
        // 取得できなかった場合や undefined だった場合はデフォルト値のまま
      }
    } catch (error) {
      // エラーが発生した場合もデフォルト値のまま
    }
    // --- ↑ ここまで追加 ---
  }
  componentWillUnmount() {
    this.props.reset();
  }
  /**
   * cropされた画像を縮小してプレビュー表示する
   */
  previewImage() {
    // // プレビューを表示するcanvas
    const previewCanvasContext = this.previewCanvasElement.getContext('2d');

    // 切り抜かれたcanvas
    const croppedCanvas = this.cropperElement.cropper.getCroppedCanvas();
    // プレビュー領域を切り抜き領域のサイズに合わせる
    this.previewCanvasElement.width = this.state.site.cropImageWidth;
    this.previewCanvasElement.height = this.state.site.cropImageHeight;
    previewCanvasContext.drawImage(
      croppedCanvas, // 描画内容
      0, 0, croppedCanvas.width, croppedCanvas.height, // 元canvasから取得する描画領域
      0, 0, this.previewCanvasElement.width, this.previewCanvasElement.height
    )
    this.setState({ isSetPreview: true });
  }

  // 画像を回転させる
  rotate(dig: number) {
    this.cropperElement.cropper.rotate(dig);
  }

  /**
   * 診断を実行する
   */
  execute(){
    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    const dataUrl = this.previewCanvasElement.toDataURL('image/jpeg');
    const imageStr = dataUrl.replace(/^.*,/,'');
    const match = dataUrl.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const contentType = (match && match.length >= 2) ? match[1] : '';
    // 推論IDを生成する
    const inferenceId = this.generateInferenceId()
    this.setState({ inferenceId });
    const koujiBangou = this.props.match.params.koujibangou;

    const completeHandler = () => {
      this.setState( {coordinatesResultsOrg : JSON.parse(JSON.stringify(this.props.inferenceResult.coordinatesResults))})
    }
    this.props.execute({ koujiBangou, inferenceId, imageStr, contentType , completeHandler});
  }

  /**
   * KansatsuKirokuScoreEditForSubdiv から岩石グループの変更を受け取るハンドラ
   */
  handleRockMassGroupChange(newGroup: string) {
    this.setState({ selectedRockMassGroup: newGroup });
  }

  /**
   * データを登録する
   */
  register() {
    // 登録するレコード
    const record = { ...this.props.kansatsuKirokuSubdiv.item };
    record.koujiBangou = this.props.match.params.koujibangou;

    record.key = uuidv4(); // 新規作成ならキーを生成する
    const kansatsuKirokuSubdivEditData = this.kansatsuKirokuSubdivEditElement.get();          // 手動で入力する観察記録の属性値を取得
    const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get();  // 人判断の評価値を取得
    record.inferenceId = this.state.inferenceId;  // 推論ID
    record.kansatsuDate = kansatsuKirokuSubdivEditData.kansatsuDate;                          // 観察記録の属性値:観察年月日
    record.sokutenNumber = kansatsuKirokuSubdivEditData.sokutenNumber;                        // 観察記録の属性値:測点No.
    record.danmenNumber = kansatsuKirokuSubdivEditData.danmenNumber;                          // 観察記録の属性値:断面番号
    record.kyori = kansatsuKirokuSubdivEditData.kyori;                                        // 観察記録の属性値:坑口からの距離[m]
    record.kansatsuDateMemo = kansatsuKirokuSubdivEditData.kansatsuDateMemo;                  // 観察記録の属性値:観察年月日:備考
    record.sokutenNumberMemo = kansatsuKirokuSubdivEditData.sokutenNumberMemo;                // 観察記録の属性値 測点No.:備考
    record.danmenNumberMemo = kansatsuKirokuSubdivEditData.danmenNumberMemo;                  // 観察記録の属性値:断面番号:備考
    record.kyoriMemo = kansatsuKirokuSubdivEditData.kyoriMemo;                                // 観察記録の属性値:坑口からの距離[m]:備考
    record.freeInputs = kansatsuKirokuSubdivEditData.freeInputs;                              // 観察記録の属性値:自由記入欄
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuSubdivEditData.freeInputs);       // 観察記録の属性値:自由記入欄 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceResultSubdivJsonStr = JSON.stringify(this.props.inferenceResult.results); // 推論結果情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceAdditionalResultSubdivJsonStr = JSON.stringify(this.props.inferenceResult.additionalResult); // AI判断 総合評価点情報
    record.observationsScoresOrgJsonStr = JSON.stringify(this.state.coordinatesResultsOrg);   // AI推論結果のオリジナル情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.croppedImageBucket = this.props.inferenceResult.croppedImage.bucket; // 切り取り済み画像の格納バケット
    record.croppedImageKey = this.props.inferenceResult.croppedImage.key;       // 切り取り済み画像の格納キー（ファイルパス）
    record.observationsScoresJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.observationsScores); // 手動スコアリングの情報
    record.inferenceAdditionalResultHumanSubdivJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.additionalResultHuman); // 人判断 総合評価点情報
    record.rockMassGroup = this.state.selectedRockMassGroup; // 選択された岩石グループを保存

    // 新規登録時は作成日時と更新日時は同一
    record.createdAt = moment().format();  //  新規作成日
    record.lastModifiedAt = record.createdAt; // 最終更新日時

    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    const originalImageStr = this.state.sourceImage.replace(/^.*,/,'');
    const match = this.state.sourceImage.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const originalImageContentType = (match && match.length >= 2) ? match[1] : '';

    this.props.postRecord(
      record,
      originalImageStr,
      originalImageContentType,
      () => {
        // 登録完了したら編集画面に移動する
        this.props.history.replace(`/subdiv/kansatsukiroku/${record.koujiBangou}/${record.key}`);
      }
    );
  }

  render() {
    const site = this.state.site || new SiteInfo();
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <Typography variant="body2">[細分化画像]</Typography>
        <Typography variant="h6">① 写真を撮影または選択</Typography>
        <Paper
          style={styles.contentBase}
        >
          <SelectPicture
            color="secondary"
            onFileSelected={(str) => this.pictureFileSelected(str)}
          />
        </Paper>
        <Typography variant="h6">② 画像位置・サイズを調整</Typography>
        <Paper
          style={styles.contentBase}
        >
          <Typography variant="body2">
            青色の枠に切羽画像を合わせてください。
          </Typography>
          <Cropper
            ref={(r) => (this.cropperElement = r)}
            src={this.state.sourceImage}
            style={{
              width: '100%',
              height: 400
            }}
            dragMode="move"
            // Cropper.js options
            aspectRatio={this.state.site.cropImageWidth / this.state.site.cropImageHeight} // 湯の上の画像の実際値
            guides={false}
          />
          <Typography variant="body2">診断画像サイズ　幅: {this.state.site.cropImageWidth}px, 高さ: {this.state.site.cropImageHeight}px</Typography>
          <Grid container spacing={16} style={{ marginTop: '10px' }} >
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(1)}
                fullWidth
              >
                <RotateRight />
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(-1)}
                fullWidth
              >
                <RotateLeft />
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(-30)}
                fullWidth
              >
                <Rotate90 /> 30°
              </Button>
            </Grid>
          </Grid>

          <Button
            color="secondary"
            disabled={!this.state.sourceImage}
            variant="contained"
            fullWidth
            style={{ marginTop: '10px' }}
            onClick={() => this.previewImage()}
          >
            画像位置を決定
          </Button>
        </Paper>

        <Typography variant="h6">③ 診断を実行する</Typography>
        <Paper
          style={styles.contentBase}
        >
          <canvas
            style={{
              width: this.state.site.cropImageWidth,
              height: this.state.site.cropImageHeight
            }}
            ref={(r) => {
              if (r) {
                this.previewCanvasElement = r;
              }
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            disabled={!this.state.isSetPreview}
            fullWidth
            style={{
              marginTop: '10px'
            }}
            onClick={() => {
              this.execute();
            }}
          >
            <CloudUpload style={{ marginRight: '5px'}}/>
            送信して診断開始
          </Button>
        </Paper>
        <Typography variant="h6">④ 診断結果</Typography>
        {/* <Paper
          style={styles.contentBase}
        >
          <div
            style={{
              display: this.props.inferenceResult.loaded ? 'block': 'none'
            }}
          >
            <InferenceResultSubdivView
              result={this.props.inferenceResult.results}
              additionalResult={this.props.inferenceResult.additionalResult}
            />
          </div>
        </Paper> */}

        <Paper
          style={styles.contentBase}
        >
        <KansatsuKirokuScoreEditForSubdiv
          disabled={!this.props.inferenceResult.loaded}
          // data={this.props.kansatsuKirokuSubdiv.item.observationsScores}
          data={this.props.inferenceResult.coordinatesResults}
          lineNum={this.state.lineNum}
          columnNum={this.state.columnNum}
          observationNames={this.state.observationNames}
          observationDescriptions={this.state.observationDescriptions}

          result={this.props.inferenceResult.results}  // 追加
          additionalResult={this.props.inferenceResult.additionalResult} // 追加
          cropImageWidth={site.cropImageWidth}
          // orgdata={this.props.kansatsuKirokuSubdiv.item.observationsScoresOrg}
          orgdata={JSON.parse(JSON.stringify(this.state.coordinatesResultsOrg))}

          // 評価値確定がステップルールの場合に必要な要素
          targetStepRuleObservationNames={site.targetStepRuleObservationNames}
          // 評価値確定が最頻値ルールの場合に必要な要素
          targetModeRuleObservationNames={site.targetModeRuleObservationNames}
          // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
          targetMeanDeduplicationRuleObservationNames={site.targetMeanDeduplicationRuleObservationNames}
          // 評価値確定が平均<一般>ルールの場合に必要な要素
          targetMeanGeneralRuleObservationNames={site.targetMeanGeneralRuleObservationNames}
          topBadsideSize={site.topBadsideSize}
          leftBadsideSize={site.leftBadsideSize}
          rightBadsideSize={site.rightBadsideSize}

          // 切羽評価点テーブル用に追加
          excavationFaceScoreConversionTableData={site.excavationFaceScoreConversionTableData}
          observationMap={site.observationMap}
          isIncludeInSubtotalObservations={site.isIncludeInSubtotalObservations}
          isIncludeInTotalObservations={site.isIncludeInTotalObservations}

          // 岩石グループ選択の初期値と変更ハンドラを渡す
          rockMassGroup={this.state.selectedRockMassGroup}
          onRockMassGroupChanged={this.handleRockMassGroupChange}

          ref={(r) => {
            if (r) {
              this.kansatsuKirokuObsrecScoreEditElement = r;
            }
          }}
        />
        </Paper>

        <Typography variant="h6">⑤ 観察記録</Typography>
        <Paper
          style={styles.contentBase}
        >
          <div
            style={{
              display: this.props.inferenceResult.loaded ? 'block': 'none'
            }}
          >
            <KansatsuKirokuEdit
              disabled={false}
              data={this.props.kansatsuKirokuSubdiv.item}
              ref={(r) => {
                if (r) {
                  this.kansatsuKirokuSubdivEditElement = r;
                }
              }}
            />
          </div>
        </Paper>
        <Button
          variant="contained"
          color="secondary"
          disabled={!this.props.inferenceResult.loaded}
          fullWidth
          onClick={() => this.register()}
          style={{ marginTop: '10px', marginBottom: '20px'}}
        >
          <CloudUpload style={{ marginRight: '5px'}}/>
          診断結果と観察記録を保存
        </Button>
        <CloseBackButton history={this.props.history} />
      </Paper>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) { // このページのProps（関数）に処理の実行の実態(reduxのoperation)をマッピング
  return {
    execute: ({ koujiBangou, inferenceId, imageStr, contentType, completeHandler }) => {
      inferenceResultSubdivOperations.execute({ koujiBangou, inferenceId, imageStr, contentType })(dispatch)
      .then(() => completeHandler());
    },
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuSubdivOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, originalImageStr, originalImageContentType, completeHandler) => {
      kansatsuKirokuSubdivOperations.post(record, originalImageStr, originalImageContentType)(dispatch)
        .then(() => completeHandler());
    },
    // ↓ 追加: getLatestRockMassGroup operation を呼び出す関数
    // operation が Promise を返すことを想定
    getLatestRockMassGroup: async (params: { koujiBangou: string }) => {
       // kansatsuKirokuSubdivOperations に getLatest が存在すると仮定
       // dispatch(getLatestRockMassGroup.async.started(params)); // started アクションは operation 内で dispatch される想定
       try {
         // operation を呼び出し、結果を待つ
         const result = await kansatsuKirokuSubdivOperations.fetchLatestRockMassGroup(params)(dispatch);
         // ↓ 取得した結果をコンソールに出力
         // console.log("Fetched result from fetchLatestRockMassGroup:", result);
         // operation が成功ペイロードを直接返すか、非同期アクションの結果を使うかは実装による
         // ここでは operation が結果を直接返すと仮定 (よりシンプル)
         // dispatch(getLatestRockMassGroup.async.done({ params, result })); // done アクションは operation 内で dispatch される想定
         return result; // 成功時のペイロード { rockMassGroup: string | undefined } を返す
       } catch (error) {
         console.error("Error fetching latest rock mass group:", error);
         // dispatch(getLatestRockMassGroup.async.failed({ params, error })); // failed アクションは operation 内で dispatch される想定
         // エラー時は void を返すか、エラーオブジェクトを rethrow するか選択
         return; // または throw error;
       }
    },
    reset: () => {
      inferenceResultSubdivOperations.reset()(dispatch);
      kansatsuKirokuSubdivOperations.resetRecord()(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) { // このページのProps（変数）にステートの内容をマッピングして読み込む
  return {
    user: appState.user,
    sites: appState.siteInfoListSubdiv,
    inferenceResult: appState.inferenceResultSubdiv,
    kansatsuKirokuSubdiv: appState.kansatsuKirokuSubdiv
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InferenceSubdivPage);



// WEBPACK FOOTER //
// ./src/components/subdiv/InferenceSubdivPage.tsx